var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.154,
    height: 30.165,
    viewBox: "0 0 28.154 30.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2280",
    "data-name": "Raggruppa 2280",
    transform: "translate(-327 -310.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-order-item-svgrepo-com",
    transform: "translate(327 310.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2271",
    "data-name": "Raggruppa 2271",
    transform: "translate(7.541 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3519",
    "data-name": "Tracciato 3519",
    d: "M38.005,26.033h11.06a1.008,1.008,0,0,0,1.005-1.005V23.016A3.025,3.025,0,0,0,47.055,20H40.016A3.025,3.025,0,0,0,37,23.016v2.011A1.008,1.008,0,0,0,38.005,26.033Z",
    transform: "translate(-37 -20)",
    fill: "#9d00ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3520",
    "data-name": "Tracciato 3520",
    d: "M47.137,25H46.132a.475.475,0,0,0-.5.5v2.011a4.034,4.034,0,0,1-4.022,4.022H30.547a4.034,4.034,0,0,1-4.022-4.022V25.5a.475.475,0,0,0-.5-.5H25.016A3.025,3.025,0,0,0,22,28.016V49.634a3.025,3.025,0,0,0,3.016,3.016H47.137a3.025,3.025,0,0,0,3.016-3.016V28.016A3.025,3.025,0,0,0,47.137,25Z",
    transform: "translate(-22 -22.486)",
    fill: "#9d00ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3521",
    "data-name": "Tracciato 3521",
    d: "M226.941,172.418a2.129,2.129,0,0,0-2.933.671l-5.773,9.2-3.332-2.954a2.127,2.127,0,0,0-2.822,3.184l5.21,4.619a2.128,2.128,0,0,0,1.411.536,2.089,2.089,0,0,0,.3-.022,2.125,2.125,0,0,0,1.5-.975l7.109-11.329A2.126,2.126,0,0,0,226.941,172.418Z",
    transform: "translate(121.426 149.516)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgente);
export default __webpack_public_path__ + "static/media/agente.a31c8caf2f1534c1e9195b166c989f13.svg";
export { ForwardRef as ReactComponent };